import { render, staticRenderFns } from "./BlackRecordConsume.vue?vue&type=template&id=36616b68&scoped=true"
import script from "./BlackRecordConsume.vue?vue&type=script&lang=js"
export * from "./BlackRecordConsume.vue?vue&type=script&lang=js"
import style0 from "./BlackRecordConsume.vue?vue&type=style&index=0&id=36616b68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36616b68",
  null
  
)

export default component.exports